import React from "react";

const ArrowDown = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M12 2v20M19 15l-7 7-7-7" />
    </g>
  </svg>
);

export default ArrowDown;



// WEBPACK FOOTER //
// ./src/theme/icons/ArrowDown.js